<template>
	<div>
		<div class="demo-upload-list" v-for="item in uploadList">
			<template>
				<img :src="item">
				<div class="demo-upload-list-cover">
					<Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
					<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
				</div>
			</template>
		</div>
		<Upload ref="upload" 
			:show-upload-list="false" 
			:on-success="handleSuccess" 
			:format="['jpg','jpeg','png']" 
			:max-size="4096" 
			:on-format-error="handleFormatError" 
			:on-exceeded-size="handleMaxSize" 
			:before-upload="handleBeforeUpload" 
			multiple type="drag" 
			:headers="setHeader" 
			name="file" 
			action="/admin/wenxue/uploadFile" 
			style="display: inline-block;width:58px;">
			<div style="width: 58px;height:58px;line-height: 58px;">
				<Icon type="ios-camera" size="20"></Icon>
			</div>
		</Upload>
		<Modal width="600px" height="400px" title="查看图片" v-model="visible">
			<img :src="imgName" v-if="visible" style="width: 100%">
		</Modal>
	</div>
</template>

<script>
	export default {
		name: 'Uploads',
		props: {
			images: {
				type: Array,
				required:true,
				default:[]
			},
			count: {
				tyle: Number,
				default: 1
			}
		},
		data() {
			return {
				imgName: '',
				visible: false,
				uploadList: [],
				imgCount: 1,
			}
		},
		methods: {
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				this.uploadList.splice(this.uploadList.indexOf(file), 1);
				
				this.$emit('send-img',this.uploadList);
			},
			handleSuccess(res, file) {
				if(this.count == 1){
					this.uploadList.splice(0,1);
				}
				
				this.uploadList.push(res['data']);
				
				this.$emit('send-img',this.uploadList);
			},
			handleFormatError(file) {
				this.$Message.warning({
					title: '文件格式错误',
					desc: '文件仅支持 jpg，jpeg or png。'
				});
			},
			handleMaxSize(file) {
				this.$Message.warning({
					title: '超出上传大小限制',
					desc: '文件  ' + file.name + ' 超出上传限制4M。'
				});
			},
			handleBeforeUpload() {
				if(this.uploadList.length > this.imgCount) {
					this.$Message.warning({
						title: '最多上传' + this.imgCount + '张图。'
					});
					
					return false;
				}
			}
		},
		computed: {
			setHeader() {
				const token = sessionStorage.getItem('token');
				return {
					token: token
				};
			}
		},
		mounted() {
			this.uploadList = this.images;
			this.imgCount = this.count;
		}
	}
</script>

<style>
	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}
	
	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}
	
	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}
	
	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}
	
	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Uploads.vue